export const appName = import.meta.env.VITE_APP_NAME || 'Brehan College'
